import { useEffect, useRef } from "react";

/**
 * 桌面演示专用：暖金"探照光"跟随指针缓慢移动，
 * 让演示现场的光标像一只灯，扫过湖面与文字。
 * 仅 (min-width:1100px + fine pointer + hover) 启用；reduced-motion 关闭。
 */
export function CursorGlow() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const media = window.matchMedia("(min-width: 1100px) and (pointer: fine) and (hover: hover)");
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (!media.matches || reduce.matches) return;

    const target = { x: window.innerWidth * 0.7, y: window.innerHeight * 0.45 };
    const current = { ...target };
    let frame = 0;
    let running = true;

    const tick = () => {
      if (!running) return;
      current.x += (target.x - current.x) * 0.06;
      current.y += (target.y - current.y) * 0.06;
      element.style.transform = `translate3d(${current.x}px, ${current.y}px, 0)`;
      frame = window.requestAnimationFrame(tick);
    };

    const onMove = (event: PointerEvent) => { target.x = event.clientX; target.y = event.clientY; };
    const onLeave = () => { target.x = -400; target.y = -400; };
    const onVisibility = () => {
      if (document.hidden) { running = false; if (frame) window.cancelAnimationFrame(frame); }
      else if (!frame) { running = true; frame = window.requestAnimationFrame(tick); }
    };

    window.addEventListener("pointermove", onMove, { passive: true });
    document.documentElement.addEventListener("pointerleave", onLeave, { passive: true });
    document.addEventListener("visibilitychange", onVisibility);
    frame = window.requestAnimationFrame(tick);
    return () => {
      running = false;
      if (frame) window.cancelAnimationFrame(frame);
      window.removeEventListener("pointermove", onMove);
      document.documentElement.removeEventListener("pointerleave", onLeave);
      document.removeEventListener("visibilitychange", onVisibility);
    };
  }, []);

  return <div className="v2-cursor-glow" ref={ref} aria-hidden="true" />;
}
